module.exports = __webpack_public_path__ + "2df7ddd0e18964bbf6241ca180ce85bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/changeTable.png
// module id = 325
// module chunks = 0